// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".press-quotes__company[data-v-79a2ec59]{max-height:60px}.press-quotes__company[data-v-79a2ec59]:not(.press-quotes__company--active){opacity:.2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
